class VitavaAccountMenu extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;

    this.initialized = true;
    this.trigger = this.querySelector('[data-account-menu-trigger]');
    this.panel = this.querySelector('[data-account-menu-popover]');

    if (!this.trigger || !this.panel) return;

    this.trigger.addEventListener('click', this.handleTriggerClick);
    document.addEventListener('pointerdown', this.handleOutsidePointerDown);
    document.addEventListener('keydown', this.handleDocumentKeyDown);
  }

  disconnectedCallback() {
    this.trigger?.removeEventListener('click', this.handleTriggerClick);
    document.removeEventListener('pointerdown', this.handleOutsidePointerDown);
    document.removeEventListener('keydown', this.handleDocumentKeyDown);
    window.clearTimeout(this.hideTimer);
  }

  handleTriggerClick = () => {
    if (this.classList.contains('is-open')) {
      this.close();
    } else {
      this.open();
    }
  };

  handleOutsidePointerDown = (event) => {
    if (this.classList.contains('is-open') && !this.contains(event.target)) {
      this.close();
    }
  };

  handleDocumentKeyDown = (event) => {
    if (event.key !== 'Escape' || !this.classList.contains('is-open')) return;

    this.close();
    this.trigger.focus();
  };

  open() {
    window.clearTimeout(this.hideTimer);
    this.panel.hidden = false;
    this.panel.setAttribute('aria-hidden', 'false');
    this.trigger.setAttribute('aria-expanded', 'true');

    requestAnimationFrame(() => this.classList.add('is-open'));
  }

  close() {
    this.classList.remove('is-open');
    this.panel.setAttribute('aria-hidden', 'true');
    this.trigger.setAttribute('aria-expanded', 'false');

    this.hideTimer = window.setTimeout(() => {
      if (!this.classList.contains('is-open')) this.panel.hidden = true;
    }, 180);
  }
}

if (!customElements.get('vitava-account-menu')) {
  customElements.define('vitava-account-menu', VitavaAccountMenu);
}
